"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionService = exports.SignatureService = void 0;
const crypto_js_1 = __importDefault(require("crypto-js"));
class SignatureService {
    // Constructor to initialize the secKey
    constructor(apiKey) {
        this.secKey = apiKey;
    }
    /**
     * Signs the given data using HMAC with SHA256.
     * @param data - The data to sign.
     * @returns The HMAC signature in base64 format.
     */
    sign(data) {
        const responseString = JSON.stringify(data);
        const hmac = crypto_js_1.default.HmacSHA256(responseString, this.secKey);
        return crypto_js_1.default.enc.Base64.stringify(hmac);
    }
    /**
     * Verifies the signature of the given data with the signature included.
     * @param dataWithSignature - The data including the signature.
     * @returns True if the signature is valid, false otherwise.
     */
    verify(dataWithSignature) {
        // Step 1: Extract the signature and remove it from the data
        const { signature, ...data } = dataWithSignature;
        // Step 2: Generate the signature from the remaining data
        const expectedSignature = this.sign(data);
        // Step 3: Compare the generated signature with the provided one
        return expectedSignature === signature;
    }
}
exports.SignatureService = SignatureService;
// This function encypts and decrypts the data the whether the passed argument is object , or string 
class EncryptionService {
    constructor(secKey) {
        this.secKey = secKey;
    }
    /**
     * Encrypts any data type (string, object, array, nested structures) using AES with multiple Base64 encodings.
     * @param data - The data to encrypt.
     * @returns The encrypted data with multiple Base64 encodings.
     */
    encrypt(data) {
        const jsonString = JSON.stringify(data);
        let encrypted = crypto_js_1.default.AES.encrypt(jsonString, this.secKey).toString();
        // Apply Base64 encoding multiple times
        encrypted = crypto_js_1.default.enc.Base64.stringify(crypto_js_1.default.enc.Utf8.parse(encrypted));
        encrypted = crypto_js_1.default.enc.Base64.stringify(crypto_js_1.default.enc.Utf8.parse(encrypted));
        return encrypted;
    }
    /**
     * Decrypts an AES-encrypted Base64 string with multiple encodings back to its original format.
     * @param encryptedData - The encrypted Base64 string with multiple encodings.
     * @returns The decrypted data in its original format.
     */
    decrypt(encryptedData) {
        // Decode Base64 multiple times before decryption
        let decrypted = crypto_js_1.default.enc.Utf8.stringify(crypto_js_1.default.enc.Base64.parse(encryptedData));
        decrypted = crypto_js_1.default.enc.Utf8.stringify(crypto_js_1.default.enc.Base64.parse(decrypted));
        const bytes = crypto_js_1.default.AES.decrypt(decrypted, this.secKey);
        const decryptedString = bytes.toString(crypto_js_1.default.enc.Utf8);
        if (!decryptedString) {
            throw new Error("Decryption failed: Invalid ciphertext or key.");
        }
        return JSON.parse(decryptedString);
    }
}
exports.EncryptionService = EncryptionService;
